module.exports = __webpack_public_path__ + "media/images/logos/logo-edone-4d2ff973742f2d29ab1d182fd2b23874.svg";